// extracted by mini-css-extract-plugin
export var matches = "matches-module--matches--vZ-DC";
export var matches__calendar = "matches-module--matches__calendar--YeLch";
export var matches__slider = "matches-module--matches__slider--QHG8d";